import TaxDocuments from './TaxDocumentsContainer';

export default TaxDocuments;
